import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import ScheduleDays from "./ScheduleDays";
import ScheduleTimes from "./ScheduleTimes";
import SchedulePrograms from "./SchedulePrograms";
import CurrentTimeIndicator from "./CurrentTimeIndicator";

export default function ChannelSchedule({ schedule }) {

    const scheduleStartTime =
        schedule.length > 0 ? schedule[0].start : new Date(0);
    const scheduleEndTime =
        schedule.length > 0
            ? schedule[schedule.length - 1].stop
            : new Date(0);
    const scheduleTotalTime = scheduleEndTime - scheduleStartTime;

    const [currentTime, setCurrentTime] = useState(new Date());

    // update current time
    useEffect(() => {
        const interval = window.setInterval(() => {
            const newTime = new Date();
            setCurrentTime((prevTime) => {
                if (newTime.getMinutes() !== prevTime.getMinutes())
                    return newTime;
                return prevTime;
            });
        }, 1000);
        return () => window.clearInterval(interval);
    }, [currentTime]);


    if (!schedule)
        return (
            <Typography>
                The schedule is not available for this station.
            </Typography>
        );

    return (
        <Box
            id="ChannelScheduleScrollBox"
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                "@media (max-height: 895px)": {
                    height: "inherit",
                },
            }}
        >
            <Stack
                id="ChannelScheduleContainer"
                direction="row"
                height={`${(scheduleTotalTime / 1000 / 60 / 60) * 10}em`} // 10em per minute
                sx={{
                    width: "100%",
                    marginTop: "1em",
                    marginBottom: "1em",
                    "@media (max-width: 750px)": {
                        marginTop: "1.5em",
                        marginBottom: "1.5em",
                    },
                }}
            >
                <ScheduleDays
                    scheduleStartTime={scheduleStartTime}
                    scheduleEndTime={scheduleEndTime}
                />
                <ScheduleTimes
                    scheduleStartTime={scheduleStartTime}
                    scheduleEndTime={scheduleEndTime}
                />
                <SchedulePrograms
                    schedule={schedule}
                    currentTime={currentTime}
                    scheduleTotalTime={scheduleTotalTime}
                />
                <CurrentTimeIndicator
                    currentTime={currentTime}
                    scheduleStartTime={scheduleStartTime}
                    scheduleEndTime={scheduleEndTime}
                />
            </Stack>
        </Box>
    );
}
